/* This file is auto-generated, manual edits in this file will be overwritten! */

export const i18nKeys = {
  common: {
    programs: 'common.programs',
    users: 'common.users',
    parameters: {
      title: 'common.parameters.title',
      admin_access: {
        title: 'common.parameters.admin_access.title',
      },
    },
    preview: 'common.preview',
    employees: 'common.employees',
    expenses: 'common.expenses',
    basic: 'common.basic',
    enrolment: 'common.enrolment',
    restriction_policies: 'common.restriction_policies',
    create: 'common.create',
    members: 'common.members',
    name: 'common.name',
    services: 'common.services',
    save: 'common.save',
    delete_program: 'common.delete_program',
    activated: 'common.activated',
    disabled: 'common.disabled',
    sum_of_employees: 'common.sum_of_employees',
    expense_policy: 'common.expense_policy',
    group: 'common.group',
    unpause: 'common.unpause',
    pause: 'common.pause',
    delete_service: 'common.delete_service',
    groups: 'common.groups',
    edit: 'common.edit',
    policies: {
      justification_not_required: 'common.policies.justification_not_required',
    },
    cancel: 'common.cancel',
    ProgramStatus: {
      ACTIVE: 'common.ProgramStatus.ACTIVE',
      INACTIVE: 'common.ProgramStatus.INACTIVE',
    },
    RegistrationStatus: {
      CANCELED: 'common.RegistrationStatus.CANCELED',
      VALIDATED: 'common.RegistrationStatus.VALIDATED',
      CREATED: 'common.RegistrationStatus.CREATED',
    },
    ActivationStatus: {
      ACTIVE: 'common.ActivationStatus.ACTIVE',
      INACTIVE: 'common.ActivationStatus.INACTIVE',
    },
    beta: 'common.beta',
    previous: 'common.previous',
    off: 'common.off',
    on: 'common.on',
    status: 'common.status',
    service: 'common.service',
    amount: 'common.amount',
    to_refund: 'common.to_refund',
    payment_date: 'common.payment_date',
    ExpenseStatus: {
      APPROVED: 'common.ExpenseStatus.APPROVED',
      REFUSED: 'common.ExpenseStatus.REFUSED',
    },
    catalog: 'common.catalog',
    category: 'common.category',
    program_list: 'common.program_list',
    update_success: 'common.update_success',
    success: 'common.success',
    refund: 'common.refund',
    created_by: 'common.created_by',
    receipt: 'common.receipt',
    see_receipt: 'common.see_receipt',
    created_at: 'common.created_at',
    program: 'common.program',
    ProductCategory: {
      car: 'common.ProductCategory.car',
      bike: 'common.ProductCategory.bike',
      motor_scooter: 'common.ProductCategory.motor_scooter',
      kick_scooter: 'common.ProductCategory.kick_scooter',
      public_transport: 'common.ProductCategory.public_transport',
      taxi: 'common.ProductCategory.taxi',
      parking: 'common.ProductCategory.parking',
      car_rent_or_lease_long_term:
        'common.ProductCategory.car_rent_or_lease_long_term',
      housing_interest: 'common.ProductCategory.housing_interest',
      fuel_charging_parking_toll:
        'common.ProductCategory.fuel_charging_parking_toll',
      company_lease_bike: 'common.ProductCategory.company_lease_bike',
      parking_at_station: 'common.ProductCategory.parking_at_station',
      fuel_or_charging: 'common.ProductCategory.fuel_or_charging',
      equipment_purchase: 'common.ProductCategory.equipment_purchase',
      'e-vehicle_purchase': 'common.ProductCategory.e-vehicle_purchase',
      'e-vehicle_leasing': 'common.ProductCategory.e-vehicle_leasing',
      housing_rent: 'common.ProductCategory.housing_rent',
      tax_free_allowance: 'common.ProductCategory.tax_free_allowance',
    },
    hello: 'common.hello',
    start: 'common.start',
    continue: 'common.continue',
    service_activation: 'common.service_activation',
    organization: 'common.organization',
    dashboard: 'common.dashboard',
    close: 'common.close',
    errors: {
      title: 'common.errors.title',
      unauthorized: {
        employee: 'common.errors.unauthorized.employee',
      },
      webview: {
        unauthorized: 'common.errors.webview.unauthorized',
      },
    },
    unauthorized: 'common.unauthorized',
    search: {
      no_suggestion: 'common.search.no_suggestion',
    },
    input: {
      email: {
        title: 'common.input.email.title',
        placeholder: 'common.input.email.placeholder',
      },
    },
    retry: 'common.retry',
    unexpected_error: 'common.unexpected_error',
    service_name: {
      bike_allowance: 'common.service_name.bike_allowance',
    },
    Provider: {
      km_allowance: 'common.Provider.km_allowance',
      nmbs: 'common.Provider.nmbs',
    },
    transactions: 'common.transactions',
    select: {
      no_options: 'common.select.no_options',
    },
    accounts: 'common.accounts',
    email: 'common.email',
    role: 'common.role',
    all: 'common.all',
    administrators: 'common.administrators',
    managers: 'common.managers',
    observers: 'common.observers',
    create_account: 'common.create_account',
    home: 'common.home',
    yes: 'common.yes',
    no: 'common.no',
    empty_table: 'common.empty_table',
    table: {
      filter_button: 'common.table.filter_button',
      active_filters: 'common.table.active_filters',
      clear_filters: 'common.table.clear_filters',
      search: 'common.table.search',
    },
  },
  fleet_manager: {
    programs: {
      page_title: 'fleet_manager.programs.page_title',
      create_program: 'fleet_manager.programs.create_program',
      details: {
        enable_program: 'fleet_manager.programs.details.enable_program',
        add_service: 'fleet_manager.programs.details.add_service',
        services_table_title:
          'fleet_manager.programs.details.services_table_title',
        subtitle: 'fleet_manager.programs.details.subtitle',
        introduction: 'fleet_manager.programs.details.introduction',
        overview: {
          date_of_program: {
            title:
              'fleet_manager.programs.details.overview.date_of_program.title',
            content:
              'fleet_manager.programs.details.overview.date_of_program.content',
          },
          eligible_employees: {
            title:
              'fleet_manager.programs.details.overview.eligible_employees.title',
            content:
              'fleet_manager.programs.details.overview.eligible_employees.content',
          },
          budget_total: {
            title: 'fleet_manager.programs.details.overview.budget_total.title',
            content:
              'fleet_manager.programs.details.overview.budget_total.content',
          },
          expense_limit: {
            title:
              'fleet_manager.programs.details.overview.expense_limit.title',
            content:
              'fleet_manager.programs.details.overview.expense_limit.content',
          },
          expense_approval: {
            title:
              'fleet_manager.programs.details.overview.expense_approval.title',
            content: {
              no_approval_needed:
                'fleet_manager.programs.details.overview.expense_approval.content.no_approval_needed',
              approval_needed:
                'fleet_manager.programs.details.overview.expense_approval.content.approval_needed',
            },
          },
        },
        parameters: {
          basic: {
            page_title:
              'fleet_manager.programs.details.parameters.basic.page_title',
            program_title:
              'fleet_manager.programs.details.parameters.basic.program_title',
            program_title_explanation:
              'fleet_manager.programs.details.parameters.basic.program_title_explanation',
            expense_date:
              'fleet_manager.programs.details.parameters.basic.expense_date',
            expense_date_explanation:
              'fleet_manager.programs.details.parameters.basic.expense_date_explanation',
          },
          enrolment: {
            page_title:
              'fleet_manager.programs.details.parameters.enrolment.page_title',
            eligible_employees:
              'fleet_manager.programs.details.parameters.enrolment.eligible_employees',
            eligible_employees_explanation:
              'fleet_manager.programs.details.parameters.enrolment.eligible_employees_explanation',
            auto_approve_enrolments:
              'fleet_manager.programs.details.parameters.enrolment.auto_approve_enrolments',
            auto_approve_enrolments_explanation:
              'fleet_manager.programs.details.parameters.enrolment.auto_approve_enrolments_explanation',
            eligible_employees_explanation_link:
              'fleet_manager.programs.details.parameters.enrolment.eligible_employees_explanation_link',
            auto_approve_enrolments_alert:
              'fleet_manager.programs.details.parameters.enrolment.auto_approve_enrolments_alert',
          },
          policies: {
            page_title:
              'fleet_manager.programs.details.parameters.policies.page_title',
            expense_policy:
              'fleet_manager.programs.details.parameters.policies.expense_policy',
            expense_policy_explanation:
              'fleet_manager.programs.details.parameters.policies.expense_policy_explanation',
            amount_limit_by_year:
              'fleet_manager.programs.details.parameters.policies.amount_limit_by_year',
            amount_by_month_limit:
              'fleet_manager.programs.details.parameters.policies.amount_by_month_limit',
            justification_required:
              'fleet_manager.programs.details.parameters.policies.justification_required',
            limit_by_year:
              'fleet_manager.programs.details.parameters.policies.limit_by_year',
            approval_policy:
              'fleet_manager.programs.details.parameters.policies.approval_policy',
            expense_approval:
              'fleet_manager.programs.details.parameters.policies.expense_approval',
            refund_approval:
              'fleet_manager.programs.details.parameters.policies.refund_approval',
            no_approval_needed:
              'fleet_manager.programs.details.parameters.policies.no_approval_needed',
            edit: {
              total_expense_limit:
                'fleet_manager.programs.details.parameters.policies.edit.total_expense_limit',
              total_expense_limit_explanation:
                'fleet_manager.programs.details.parameters.policies.edit.total_expense_limit_explanation',
              monthly_expense_limit:
                'fleet_manager.programs.details.parameters.policies.edit.monthly_expense_limit',
              monthly_expense_limit_explanation:
                'fleet_manager.programs.details.parameters.policies.edit.monthly_expense_limit_explanation',
              monthly_expense_limit_warning:
                'fleet_manager.programs.details.parameters.policies.edit.monthly_expense_limit_warning',
              total_expense_limit_warning:
                'fleet_manager.programs.details.parameters.policies.edit.total_expense_limit_warning',
              toggle_monthly_limit:
                'fleet_manager.programs.details.parameters.policies.edit.toggle_monthly_limit',
              expense_approval:
                'fleet_manager.programs.details.parameters.policies.edit.expense_approval',
              approval_explanation:
                'fleet_manager.programs.details.parameters.policies.edit.approval_explanation',
              approval_option: {
                enabled:
                  'fleet_manager.programs.details.parameters.policies.edit.approval_option.enabled',
                disabled:
                  'fleet_manager.programs.details.parameters.policies.edit.approval_option.disabled',
              },
              refund_approval:
                'fleet_manager.programs.details.parameters.policies.edit.refund_approval',
            },
          },
          update: {
            success: 'fleet_manager.programs.details.parameters.update.success',
          },
        },
        service_table_subtitle:
          'fleet_manager.programs.details.service_table_subtitle',
        employees: {
          employees_table_title:
            'fleet_manager.programs.details.employees.employees_table_title',
          employees_table_subtitle:
            'fleet_manager.programs.details.employees.employees_table_subtitle',
        },
        expenses: {
          page_title: 'fleet_manager.programs.details.expenses.page_title',
          details: {
            title: 'fleet_manager.programs.details.expenses.details.title',
          },
        },
        disable_program: 'fleet_manager.programs.details.disable_program',
      },
      create: {
        page_title: 'fleet_manager.programs.create.page_title',
        page_explanation: 'fleet_manager.programs.create.page_explanation',
        call_to_action: 'fleet_manager.programs.create.call_to_action',
      },
    },
    services: {
      details: {
        page_subtitle: 'fleet_manager.services.details.page_subtitle',
        allowance_amount_by_km:
          'fleet_manager.services.details.allowance_amount_by_km',
        allowance_amount_by_km_explanation:
          'fleet_manager.services.details.allowance_amount_by_km_explanation',
        max_km_per_journeys:
          'fleet_manager.services.details.max_km_per_journeys',
        office_address: 'fleet_manager.services.details.office_address',
        page_title: 'fleet_manager.services.details.page_title',
        max_km_per_journeys_explanation:
          'fleet_manager.services.details.max_km_per_journeys_explanation',
        update: {
          success: 'fleet_manager.services.details.update.success',
        },
        max_km_per_journeys_warning:
          'fleet_manager.services.details.max_km_per_journeys_warning',
        allowance_amount_by_km_warning:
          'fleet_manager.services.details.allowance_amount_by_km_warning',
      },
      create: {
        page_title: 'fleet_manager.services.create.page_title',
        page_explanation: 'fleet_manager.services.create.page_explanation',
        call_to_action: 'fleet_manager.services.create.call_to_action',
      },
    },
    users: {
      employees: {
        page_title: 'fleet_manager.users.employees.page_title',
        invite_employee: 'fleet_manager.users.employees.invite_employee',
      },
      groups: {
        page_title: 'fleet_manager.users.groups.page_title',
        create_group: 'fleet_manager.users.groups.create_group',
      },
    },
  },
  employee: {
    dashboard: {
      service_introduction: {
        title: 'employee.dashboard.service_introduction.title',
        content: 'employee.dashboard.service_introduction.content',
        call_to_action:
          'employee.dashboard.service_introduction.call_to_action',
      },
      service_activation: {
        title: 'employee.dashboard.service_activation.title',
        subtitle: 'employee.dashboard.service_activation.subtitle',
        body: {
          title: 'employee.dashboard.service_activation.body.title',
          content: 'employee.dashboard.service_activation.body.content',
        },
        trip_type: {
          title: 'employee.dashboard.service_activation.trip_type.title',
          subtitle: 'employee.dashboard.service_activation.trip_type.subtitle',
          options: {
            complete: {
              title:
                'employee.dashboard.service_activation.trip_type.options.complete.title',
              subtitle:
                'employee.dashboard.service_activation.trip_type.options.complete.subtitle',
            },
            partial: {
              title:
                'employee.dashboard.service_activation.trip_type.options.partial.title',
              subtitle:
                'employee.dashboard.service_activation.trip_type.options.partial.subtitle',
            },
            complete_partial: {
              title:
                'employee.dashboard.service_activation.trip_type.options.complete_partial.title',
              subtitle:
                'employee.dashboard.service_activation.trip_type.options.complete_partial.subtitle',
            },
          },
        },
        end: {
          title: 'employee.dashboard.service_activation.end.title',
          body: {
            title: 'employee.dashboard.service_activation.end.body.title',
            subtitle: 'employee.dashboard.service_activation.end.body.subtitle',
            call_to_action:
              'employee.dashboard.service_activation.end.body.call_to_action',
            cancel: 'employee.dashboard.service_activation.end.body.cancel',
          },
        },
        itinerary_configuration: {
          title: {
            complete:
              'employee.dashboard.service_activation.itinerary_configuration.title.complete',
            partial:
              'employee.dashboard.service_activation.itinerary_configuration.title.partial',
          },
          subtitle: {
            complete:
              'employee.dashboard.service_activation.itinerary_configuration.subtitle.complete',
            partial:
              'employee.dashboard.service_activation.itinerary_configuration.subtitle.partial',
          },
          home_address:
            'employee.dashboard.service_activation.itinerary_configuration.home_address',
          work_address:
            'employee.dashboard.service_activation.itinerary_configuration.work_address',
          allowance_amount:
            'employee.dashboard.service_activation.itinerary_configuration.allowance_amount',
          complete_trip_confirm:
            'employee.dashboard.service_activation.itinerary_configuration.complete_trip_confirm',
          partial_trip_confirm:
            'employee.dashboard.service_activation.itinerary_configuration.partial_trip_confirm',
          first_km_itinerary:
            'employee.dashboard.service_activation.itinerary_configuration.first_km_itinerary',
          last_km_itinerary:
            'employee.dashboard.service_activation.itinerary_configuration.last_km_itinerary',
          errors: {
            itinerary_not_found: {
              start:
                'employee.dashboard.service_activation.itinerary_configuration.errors.itinerary_not_found.start',
              end:
                'employee.dashboard.service_activation.itinerary_configuration.errors.itinerary_not_found.end',
            },
          },
        },
        organisation_policies: {
          title:
            'employee.dashboard.service_activation.organisation_policies.title',
          subtitle:
            'employee.dashboard.service_activation.organisation_policies.subtitle',
          link:
            'employee.dashboard.service_activation.organisation_policies.link',
        },
      },
      create_trip: 'employee.dashboard.create_trip',
      trip_list: 'employee.dashboard.trip_list',
      budget_overview: {
        title: 'employee.dashboard.budget_overview.title',
        subtitle: 'employee.dashboard.budget_overview.subtitle',
        limit: 'employee.dashboard.budget_overview.limit',
        progress_caption: {
          in_progress:
            'employee.dashboard.budget_overview.progress_caption.in_progress',
          available:
            'employee.dashboard.budget_overview.progress_caption.available',
        },
      },
    },
    service_activation: 'employee.service_activation',
    add_trip: {
      title: 'employee.add_trip.title',
      subtitle: 'employee.add_trip.subtitle',
      outward_trip_type: {
        title: 'employee.add_trip.outward_trip_type.title',
        complete: {
          title: 'employee.add_trip.outward_trip_type.complete.title',
          subtitle: 'employee.add_trip.outward_trip_type.complete.subtitle',
        },
        partial: {
          title: 'employee.add_trip.outward_trip_type.partial.title',
          subtitle: 'employee.add_trip.outward_trip_type.partial.subtitle',
        },
        none: {
          title: 'employee.add_trip.outward_trip_type.none.title',
          subtitle: 'employee.add_trip.outward_trip_type.none.subtitle',
        },
      },
      return_trip_type: {
        title: 'employee.add_trip.return_trip_type.title',
        complete: {
          title: 'employee.add_trip.return_trip_type.complete.title',
          subtitle: 'employee.add_trip.return_trip_type.complete.subtitle',
        },
        partial: {
          title: 'employee.add_trip.return_trip_type.partial.title',
          subtitle: 'employee.add_trip.return_trip_type.partial.subtitle',
        },
        none: {
          title: 'employee.add_trip.return_trip_type.none.title',
          subtitle: 'employee.add_trip.return_trip_type.none.subtitle',
        },
      },
      call_to_action: 'employee.add_trip.call_to_action',
      success: {
        title: 'employee.add_trip.success.title',
        cancel: 'employee.add_trip.success.cancel',
      },
      cost_estimation: {
        to: 'employee.add_trip.cost_estimation.to',
        back: 'employee.add_trip.cost_estimation.back',
        both: 'employee.add_trip.cost_estimation.both',
      },
    },
    cancel_trip: {
      title: 'employee.cancel_trip.title',
    },
  },
  sidebar: {
    fleet_manager: {
      invite_employee: 'sidebar.fleet_manager.invite_employee',
    },
    common: {
      help: 'sidebar.common.help',
    },
  },
  table: {
    search: {
      placeholder: {
        employee: 'table.search.placeholder.employee',
      },
    },
  },
  input: {
    search: {
      placeholder: {
        address: {
          home: 'input.search.placeholder.address.home',
          last_km: 'input.search.placeholder.address.last_km',
          first_km: 'input.search.placeholder.address.first_km',
        },
      },
    },
  },
  http_errors: {
    kmallowance_common_configuration_not_found:
      'http_errors.kmallowance_common_configuration_not_found',
    routing_common_itinerary_not_found:
      'http_errors.routing_common_itinerary_not_found',
    authentication_user_not_found: 'http_errors.authentication_user_not_found',
    authentication_wrong_password: 'http_errors.authentication_wrong_password',
    authentication_refused: 'http_errors.authentication_refused',
  },
  auth: {
    login: {
      title: 'auth.login.title',
      password: {
        title: 'auth.login.password.title',
        placeholder: 'auth.login.password.placeholder',
      },
      call_to_action: 'auth.login.call_to_action',
      forgot_password: 'auth.login.forgot_password',
      errors: {
        wrong_password: 'auth.login.errors.wrong_password',
        user_not_found: 'auth.login.errors.user_not_found',
      },
    },
    first_set_password: {
      title: 'auth.first_set_password.title',
      email: {
        title: 'auth.first_set_password.email.title',
      },
      password: {
        title: 'auth.first_set_password.password.title',
        placeholder: 'auth.first_set_password.password.placeholder',
      },
      confirm_password: {
        title: 'auth.first_set_password.confirm_password.title',
      },
      call_to_action: 'auth.first_set_password.call_to_action',
    },
    reset_password: {
      title: 'auth.reset_password.title',
      subtitle: 'auth.reset_password.subtitle',
      call_to_action: 'auth.reset_password.call_to_action',
      success: {
        title: 'auth.reset_password.success.title',
        subtitle: 'auth.reset_password.success.subtitle',
        content: 'auth.reset_password.success.content',
        call_to_action: 'auth.reset_password.success.call_to_action',
      },
      errors: {
        invalid_token: {
          title: 'auth.reset_password.errors.invalid_token.title',
          content: 'auth.reset_password.errors.invalid_token.content',
        },
        invalid_email: 'auth.reset_password.errors.invalid_email',
      },
    },
    confirm_reset_password: {
      title: 'auth.confirm_reset_password.title',
      subtitle: 'auth.confirm_reset_password.subtitle',
      password: {
        title: 'auth.confirm_reset_password.password.title',
        placeholder: 'auth.confirm_reset_password.password.placeholder',
      },
      confirm_password: {
        title: 'auth.confirm_reset_password.confirm_password.title',
      },
      success_message: 'auth.confirm_reset_password.success_message',
    },
  },
  header: {
    logout: 'header.logout',
  },
  parameters: {
    title: 'parameters.title',
    admin_access: {
      sub_title: 'parameters.admin_access.sub_title',
      create_account: 'parameters.admin_access.create_account',
      title: 'parameters.admin_access.title',
      search_placeholder: 'parameters.admin_access.search_placeholder',
      dialog: {
        account_for: 'parameters.admin_access.dialog.account_for',
      },
    },
  },
  pager: {
    rows_per_page: 'pager.rows_per_page',
    entries: 'pager.entries',
  },
  login: {
    title: 'login.title',
    profile: 'login.profile',
  },
};
